import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AdjacentType, edgeTypeMatrix } from '@iotv/datamodel-core';
import { DefaultStepTypeFolderClickWrapper, DefaultLabelClickWrapper, } from '../../../v2/components/generic/ObjectTree';
import { getIconForType } from '../../../Iconography';
import { andVobFilter } from '@iotv/core-services';
const debug = process.env.REACT_APP_DEBUG && false;
/** Customer to Device Group */
export const getCustomerDeviceGroupStep = ({ filters: filtersIn }) => {
    const filters = [
        (vob) => vob?.supportedType === 'Device',
        ...filtersIn
    ];
    const customerDeviceGroupStep = { stepQuery: {
            objectTypeId: 'Group',
            adjacencyType: AdjacentType.CHILD,
            edgeTypeId: edgeTypeMatrix.Customer.Group.customer_has_group.edgeTypeId,
        },
        nodeFilter: andVobFilter(filters),
        nextSteps: [],
        renderTypeFolder: false,
        thisStepTypeFolderClickWrapper: (props) => (_jsx(DefaultStepTypeFolderClickWrapper, { ...props, element: _jsx(_Fragment, { children: "Device Groups" }), support: 'Device' })),
        thisStepLabelWrapper: DefaultLabelClickWrapper, };
    const groupDeviceStep = {
        stepQuery: {
            objectTypeId: 'Device',
            adjacencyType: AdjacentType.CHILD,
            edgeTypeId: edgeTypeMatrix.Group.Device.group_has_device.edgeTypeId,
        },
        endIcon: getIconForType('Device'),
        thisStepLabelWrapper: DefaultLabelClickWrapper,
        nextSteps: [],
    };
    customerDeviceGroupStep.nextSteps?.push(groupDeviceStep);
    //device group recursion!!
    const deviceSubGroupStep = {
        stepQuery: {
            objectTypeId: 'Group',
            adjacencyType: AdjacentType.CHILD,
            edgeTypeId: edgeTypeMatrix.Group.Group.group_has_subGroup.edgeTypeId,
        },
        nodeFilter: (vob) => vob?.supportedType === 'Device',
        endIcon: getIconForType('Device'),
        nextSteps: [groupDeviceStep],
    };
    deviceSubGroupStep.nextSteps?.push(deviceSubGroupStep);
    customerDeviceGroupStep.nextSteps?.push(deviceSubGroupStep);
    return customerDeviceGroupStep;
};
export const customerDeviceGroupStep = getCustomerDeviceGroupStep({ filters: [] });
